import {
  ADD_CARD_FAILED,
  ADD_CARD_INVALID_REQUEST,
  ADD_CARD_SUCCESS,
  ADD_CARD_EXIST,
  RESET_ADD_CARD,
  LOADING_ADD_CARD
} from "../types";

const initialState = {
  isLoading: false,
  cardExist: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADD_CARD:
      return {
        ...state,
        isLoading: true,
        cardExist: false,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
        data: {}
      };
    case ADD_CARD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        cardExist: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload
      };
    case ADD_CARD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        cardExist: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload
      };
    case ADD_CARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        cardExist: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload
      };

    case ADD_CARD_EXIST:
      return {
        ...state,
        isLoading: false,
        failed: false,
        cardExist: true,
        success: false,
        invalidRequest: false,
        networkError: "",
        data: action.payload
      };

    case RESET_ADD_CARD:
      return (state = initialState);

    default:
      return state;
  }
};
